import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { providePlattformBrowser } from './browser.providers';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  exports: [],
})
export class BrowserModule {
  static forRoot(): ModuleWithProviders<BrowserRootModule> {
    return {
      ngModule: BrowserRootModule,
      providers: [
        providePlattformBrowser(),
      ],
    };
  }
}

@NgModule({
  declarations: [],
  imports: [CommonModule, BrowserModule],
  exports: [],
})
export class BrowserRootModule {
  constructor() {
  }
}
